export type Appearance = "light" | "dark" | "system"

const prefersDark = () => {
  if (typeof window === "undefined") {
    return false
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches
}

const applyTheme = (appearance: Appearance) => {
  const isDark =
    appearance === "dark" || (appearance === "system" && prefersDark())

  document.documentElement.classList.toggle("dark", isDark)
  document.documentElement.style.colorScheme = isDark ? "dark" : "light"
}

export function initializeTheme() {
  applyTheme("light")
}

export function useAppearance() {
  return {
    appearance: "light" as Appearance,
    updateAppearance: (_mode: Appearance) => {
      void _mode
    },
  } as const
}
